import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { injectDevFlagSignal } from '@core/tellent-dev-flags-logic';
import { TellentDevFlag, TellentMember } from '@core/tellent-types';
import { resolveMemberFullName } from '@core/tellent-util';
import { AvatarComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-member-box',
  templateUrl: './member-box.component.html',
  styleUrl: './member-box.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AvatarComponent],
})
export class MemberBoxComponent {
  public member = input.required<TellentMember>();

  protected usersWithoutEmails = injectDevFlagSignal(TellentDevFlag.UsersWithoutEmails);

  protected avatarThumbUrl = computed(() => this.member().avatarThumbUrl ?? '');

  protected email = computed(() => this.member().email);

  protected fullName = computed(() => resolveMemberFullName(this.member()));

  protected hasWorkEmail = computed(() => {
    if (!this.usersWithoutEmails()) {
      return true;
    }
    return this.member().hasWorkEmail;
  });
}
